<style>
</style>
<template>
<v-row dense>
<!--  <v-col cols="12">-->
<!--    <setting-value id="company" name="company" v-model="value.customerName" :default-value="defaultValue.customerName" :counter="100"></setting-value>-->
<!--  </v-col>-->
  <v-col cols="6">
    <setting-value id="ic" name="ic" v-model="value.idKey" :default-value="defaultValue.idKey" :counter="10"></setting-value>
  </v-col>
  <v-col cols="6">
    <setting-value id="dic" name="dic" v-model="value.countryId" :default-value="defaultValue.countryId" :counter="12"></setting-value>
  </v-col>
</v-row>
</template>
<script>
import SettingValue from '../components/setting-value.vue'
import TransformMixin from '../mixins/transform-mixin.js'
export default {
  name: 'setting-company',
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    defaultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    // input: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  components: {
    'setting-value': SettingValue
  },
  mixins: [TransformMixin],
  // data() {
  //   return {
  //     inputValue: this.value ? this.value : {}
  //   }
  // },
  computed: {
    // customerName: {
    //   get() {
    //     return this.inputValue.customerName
    //   },
    //   set(value) {
    //     this.inputValue.customerName = value
    //     this.$emit('input', this.inputValue)
    //   }
    // },
    // idKey: {
    //   get() {
    //     return this.inputValue.idKey
    //   },
    //   set(value) {
    //     this.inputValue.idKey = value
    //     this.$emit('input', this.inputValue)
    //   }
    // },
    // countryId: {
    //   get() {
    //     return this.inputValue.countryId
    //   },
    //   set(value) {
    //     this.inputValue.countryId = value
    //     this.$emit('input', this.inputValue)
    //   }
    // }
  }
  // ,
  // watch: {
  //   customerName(value) {
  //     console.log(value)
  //     this.inputValue.customerName = value
  //   }
  // }
  // ,
  // methods: {
  //   // pri zmene vstupu se odesle na parent
  //   onInput() {
  //     console.log(this.inputValue.customerName)
  //     this.$emit('input', this.inputValue)
  //   }
  // }
}
</script>
